module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic05.4a1d0b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic05.png
// module id = 505
// module chunks = 1